import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {Form, Formik} from 'formik';
import messages from '../../../../res/translations/messages';

class SendProviderParameters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    toggleModal() {
        this.setState({modal: !this.state.modal});
    }

    handleSubmit(values) {
        values = Object.assign({}, this.props.values, values);
        this.props.setFieldValue(`organization.sendProviders.${this.props.provider}`, values);
        this.toggleModal();
    }

    render() {
        const {provider, children, values, validationSchema} = this.props;
        const enabled = !!(values && values.enabled);
        return (
            <button type="button" className="btn btn-sm btn-outline-secondary" disabled={!enabled} onClick={this.toggleModal}>
                <FormattedMessage {...messages.buttons.sendProviderConfig} />
                <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage {...messages.admin.organization.sendProviders[provider].name} />
                    </ModalHeader>
                    <Formik
                        onSubmit={this.handleSubmit}
                        initialValues={values || {}}
                        validateOnBlur={true}
                        validateOnChange={true}
                        validationSchema={validationSchema}
                    >
                        {({handleSubmit, isSubmitting, errors}) => {
                            return (
                                <Form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        {children}
                                    </ModalBody>
                                    <ModalFooter>
                                        <button className="btn btn-primary" type="submit" disabled={!!Object.keys(errors).length || isSubmitting}>
                                            <FormattedMessage {...messages.buttons.ok} />
                                        </button>
                                    </ModalFooter>
                                </Form>
                            );
                        }
                        }
                    </Formik>

                </Modal>
            </button>
        );
    }
}

export default SendProviderParameters;
